import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a741fb85683954beff376fb70841e8270b from "./generated-377e310e-5949-4775-90d6-1063c54134ba.json";

import a0d837720f7afb2fc7d64010802e5629ab from "./generated-55e6df67-12e7-476a-bab5-454f979cbc96.json";

import a647b36a0cdd98f3923477f17752a5152b from "./generated-877d53d9-d223-4b5c-bd08-09ed38ea42ac.json";

import ad5f002fef455f233f802c6a8f516d07fb from "./generated-b0317255-b7d1-445d-bdd1-ee3d11843acf.json";

import ab2b3e5952be3b28f920be3d349a2b144b from "./generated-a487e295-c1dc-4c58-9696-beec4baf83b1.json";

import a8c587340a497537f368b0c22a76eed76b from "./generated-24abea09-814a-4901-a8f2-d0d904fe75a0.json";

import aee1fdcd78e43b18e7d94242e894060a0b from "./generated-f0c9ce41-08a6-4ae5-83ba-2b60e50d099c.json";

import a948b0125518fcae6b1d608558b22f924b from "./generated-dba22bdd-4155-4208-bfb3-3d53dfc69004.json";

import a05d23880b6296eb926d01d398552e39db from "./generated-3bedf908-af5b-49f1-8cd0-8aeafccb7793.json";

import a25bff2de6d47656c116a95c6fd86bc18b from "./generated-47cf8473-4480-4513-bd32-f9f83e8a9929.json";

import a5a50f2f1120f6f698202222becd8b7e7b from "./generated-9cd7b7a2-85d7-4a0f-b4ab-8a08722585cc.json";

import adb3538fb6598e1fad2268c25cbb973f5b from "./generated-566efc48-bde9-48c3-a65d-6640aeffa1c8.json";

import a92233c563c1687a7dfd719bbc7d90adab from "./generated-e587b15e-910c-4c3e-a47f-fb17d2adc011.json";

import a058f9101eebea36ea9f12c044a87ffeeb from "./generated-f95dafe2-5320-4692-a60a-647f0b737772.json";

import a935b4b6084b256788fe5e02f4ad365cfb from "./generated-ebe5131f-301e-4f82-ba6e-e81c702247d3.json";

import adb9fffbc9fb43b8003130e2e73bdaa96b from "./generated-b0734ab7-b77e-41a1-9e3f-2441f974d65f.json";

import ac95a47acdb805b1833b39d7ca34c02fab from "./generated-71353471-43c5-4ff1-9b0f-7a7b0fe6bcde.json";

import a6333202231340f4d3ec7373383cd2d48b from "./generated-e3f845fc-2a25-41e3-ad7e-ea9a6e043d59.json";

import a6455433424836d6c85d36cd5d7dc9341b from "./generated-9e88d1f9-62db-42b9-ada4-fbf2af1e0fbc.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a741fb85683954beff376fb70841e8270b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a0d837720f7afb2fc7d64010802e5629ab);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a647b36a0cdd98f3923477f17752a5152b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ad5f002fef455f233f802c6a8f516d07fb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ab2b3e5952be3b28f920be3d349a2b144b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a8c587340a497537f368b0c22a76eed76b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aee1fdcd78e43b18e7d94242e894060a0b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a948b0125518fcae6b1d608558b22f924b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a05d23880b6296eb926d01d398552e39db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a25bff2de6d47656c116a95c6fd86bc18b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a5a50f2f1120f6f698202222becd8b7e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(adb3538fb6598e1fad2268c25cbb973f5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a92233c563c1687a7dfd719bbc7d90adab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a058f9101eebea36ea9f12c044a87ffeeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a935b4b6084b256788fe5e02f4ad365cfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(adb9fffbc9fb43b8003130e2e73bdaa96b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ac95a47acdb805b1833b39d7ca34c02fab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a6333202231340f4d3ec7373383cd2d48b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a6455433424836d6c85d36cd5d7dc9341b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ac95a47acdb805b1833b39d7ca34c02fab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */